//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { isLoading } from 'state/reducers/beneficiary.reducers';
//mui
import { Box } from '@mui/system';
import { Button, Stack, useTheme } from '@mui/material';
import { FormButton } from 'theme/elements/Buttons';
import { getMobile } from 'state/reducers/ui.reducers';

type footerProps = {
  handleCancel: any;
  handleBack: any;
  ifBack: boolean;
  ifNoCancel?: boolean;
  handleSubmit: any;
  disableSubmit?: boolean;
  labelSubmit?: string;
  labelCancel?: string;
  labelBack?: string;
  disableBack?: boolean;
  disableCancel?: boolean;
};

export default function Footer(props: footerProps) {
  const loading: boolean = useAppSelector(isLoading);
  const isMobile = useAppSelector(getMobile);
  const className = isMobile || (props.ifNoCancel && !props.ifBack) ? 'singleFormButton' : '';
  const FormButtonWidth = { width: isMobile || (props.ifNoCancel && !props.ifBack) ? '100%' : 'auto' };

  return (
    <Box
      justifyContent="space-between"
      display="flex"
      flexDirection={isMobile || (props.ifNoCancel && !props.ifBack) ? 'column' : 'row'}
    >
      {!props.ifNoCancel ? (
        <FormButton sx={FormButtonWidth}>
          <Button
            variant="text"
            className={className}
            disabled={loading || props.disableCancel}
            onClick={() => {
              props.handleCancel();
            }}
          >
            {props.labelCancel || 'Cancel'}
          </Button>
        </FormButton>
      ) : (
        <Box></Box>
      )}
      <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1}>
        {props.ifBack && (
          <FormButton>
            <Button
              variant="outlined"
              disabled={props.disableBack || loading}
              className={className}
              onClick={() => {
                props.handleBack();
              }}
            >
              {props.labelBack || 'Back'}
            </Button>
          </FormButton>
        )}
        <FormButton sx={FormButtonWidth}>
          <Button
            onClick={() => props.handleSubmit()}
            variant="contained"
            className={className}
            disabled={props.disableSubmit || loading}
          >
            {props.labelSubmit}
          </Button>
        </FormButton>
      </Stack>
    </Box>
  );
}
